import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from 'react';
import isEqual from 'react-fast-compare';

import { Select, MenuItem, ListSubheader, TextField, InputAdornment, FormControl } from '@material-ui/core';

import { colors, roles, sharingValues, modules } from '../../../Shared/utils';

import { multiSelectStrings } from '../../../Functions/utils';
// import { getGroups } from '../../../Functions/reporting';
import { update } from '../../../Functions/admin';

import { useAppContext } from '../../../Context/App/Provider';
import { useEventContext } from '../../../Context/Event/Provider';
import { useReportingContext } from '../../../Context/Reporting/Provider';

import './LocationSelect.css';


export default function LocationSelect({ onChangeLocations }) {
  const { t } = useTranslation();

  // const loading = false;
  const [{ pickers, selected }, dispatch] = useReportingContext(); // reporting context
  const [{ user, loading }, appDispatch] = useAppContext(); // global context
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();

  const [savedSelectedLocations, setSavedSelectedLocations] = useState(selected.locations);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  // console.log("30 - savedSelectedLocations=", savedSelectedLocations);
  const setSelectedLocations = (locations) => {
    // console.log("31 - setSelectedLocations=", locations);
    dispatch({
      pickers: {
        ...pickers,
      },
      selected: {
        ...selected,
        locations: locations
      }
    });
  }

  const handleSelectLocation = (e, location) => {
    e.preventDefault();

    // console.log("57 - handleSelectLocation=", location);
    const newSelectedLocations = selected.locations.filter((loc) => loc.value !== location.value);

    if (newSelectedLocations.length === selected.locations.length)
      newSelectedLocations.push(location)

    setSelectedLocations(newSelectedLocations);

    // console.log("56 - newSelectedLocations=", newSelectedLocations);
  }

  let locationsName = '';
  let allSelected = false;

  // console.log("77 - pickers=", pickers);
  // console.log("78 - selected=", selected);

  // console.log("80 - pickers.locations.show=", pickers.locations.show);


  if (selected.locations) {
    locationsName = selected.locations && selected.locations.map(loc => loc.label.trim()).join(', ');
  }
  
  if (pickers.locations.show && selected.locations) {
    allSelected = pickers.locations.show.filter(o => o.group).length === selected.locations.length
  }

  const values = [];
  for (const loc of selected.locations) {
    values.push(loc.label);
  }

  const disabled = loading || (selected.groups && selected.groups.length === 0) || (groupsLocationsStatus === "loading");

  return (
    <Select className="sidebar__select"
      style={{
        display: "flex",

        width: '100%',
        height: '34px',
        padding: '0 8px',
        maxWidth: '1000%',
        outline: '0',
        // cursor: 'pointer',
        fontSize: '15px',
        fontWeight: '600',
        fontFamily: 'inherit',

        transition: '0.25s',
        color: 'rgb(var(--accent-color))',
        borderRadius: 'var(--radius-small)',
        backgroundColor: 'var(--select-bg)',
        border: '0 px solid var(--separation-color-light)',

        opacity: (disabled || (pickers.locations.show && pickers.locations.show.length === 0)) ? '0.4' : '1',
        cursor: (disabled || (pickers.locations.show && pickers.locations.show.length === 0)) ? 'not-allowed' : 'pointer'
      }}

      disabled={disabled}

      id='location_selecter'
      variant='outlined'
      multiple
      displayEmpty

      title={locationsName}

      open={locationsOpen}

      onClose={() => {
        setLocationsOpen(false);

        if (onChangeLocations && !isEqual(savedSelectedLocations, selected.locations)) {
          setSavedSelectedLocations(selected.locations)
          onChangeLocations(selected.locations);
        }
      }}
      onOpen={() => {
        setSearchText('');
        setLocationsOpen(true)
      }}

      labelWidth={0}

      value={values}
      onChange={e => {
      }}

      renderValue={value => {

        if (value.length === 0) {
          return (
            <span
              style={{
                width: "100%",
                maxWidth: "100%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '500',
                //fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))',

              }}>
              {multiSelectStrings(t, 'loc', selected).selectSomeItems}
            </span>
          )
        }
        return (
          <div
            style={{ width: "90%", display: 'flex' }}
          >
            <span
              style={{
                width: "94%",
                maxWidth: "94%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '500',
                fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))',
                overflow: 'hidden',
                textOverflow: 'ellipsis'

              }}>{locationsName}
            </span>
          </div>

        )
      }}
    >
      <ListSubheader id="location_selecter_search">
        <TextField
          size="small"
          autoFocus
          placeholder={multiSelectStrings(t, 'loc', selected).search}
          fullWidth
          InputProps={{
            startAdornment: <InputAdornment position="start">
              <span
                style={{
                  fontSize: '20px',
                }}
                className="material-icons-outlined">search</span>
            </InputAdornment>
          }}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              e.stopPropagation();
            }
          }}
        />
      </ListSubheader>

      <MenuItem value="choose" style={{ display: 'none' }}>
        {''}
      </MenuItem>

      <MenuItem
        value={"all"}

        style={{
          paddingLeft: '6px',
          paddingRight: '20px',
          lineHeight: '20px',
          display: 'flex'
        }}

        onClick={(e) => {
          e.stopPropagation();
          if (allSelected)
            setSelectedLocations([]);
          else
            setSelectedLocations(pickers.locations.show.filter(o => o.group));
        }}
      >
        <span
          className={"material-icons"}
          // title={t('global.checked')}
          style={{
            textAlign: 'left',
            width: '8%',
            fontSize: '16px',
            color: allSelected ? 'rgb(var(--favorite-color))' : 'initial'
          }}
        >
          {allSelected ? 'check_box' : 'check_box_outline_blank'}
        </span>

        <span
          style={{
            padding: '0 4px',
            width: "92%",
            maxWidth: "100%",
            textAlign: 'left',
            fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
            transition: '0.25s',
            //color: allSelected ? 'rgb(var(--favorite-color))' : 'initial'   
            color: 'grey'
          }}
        >
          {multiSelectStrings(t, 'loc', selected).selectAll}
        </span>
      </MenuItem >


      {pickers.locations.show && pickers.locations.show.length > 0 ? (
        pickers.locations.show.map((location, key) => {

          const isSelected = selected.locations.find((element) => {
            return (element.value === location.value);
          });
          const isDisplayed = (location.label.toLowerCase().indexOf(searchText.toLowerCase()) > -1);


          if (user.roleId > roles.stAdmin || (location.value === "" || (location.label && location.label.charAt(0) === '\u2001'))) {
            return (
              <MenuItem
                value={location.id}
                name={location.label}

                style={{
                  paddingLeft: '6px',
                  paddingRight: '20px',
                  display: (isDisplayed || isSelected) ? 'flex' : 'none'
                }}

                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectLocation(e, location)
                }}
              >
                <span
                  className={"material-icons"}
                  // title={t('global.checked')}
                  style={{
                    textAlign: 'left',
                    width: '8%',
                    fontSize: '16px',
                    color: isSelected !== undefined ? 'rgb(var(--favorite-color))' : 'initial'
                  }}
                >
                  {isSelected !== undefined ? 'check_box' : 'check_box_outline_blank'}
                </span>

                <span
                  style={{
                    padding: '0 4px',
                    width: "84%",
                    maxWidth: "100%",
                    textAlign: 'left',
                    fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                    transition: '0.25s',
                  }}
                >{location.label.trim()}
                </span>
              </MenuItem >
            )
          }
          else {
            return (
              <ListSubheader
                value={location.id}
                name={location.label}

                style={{
                  paddingLeft: '6px',
                  paddingRight: '20px',
                  display: (isDisplayed || isSelected) ? 'flex' : 'none'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <span
                  style={{
                    padding: '8px 0px 0px 0px',
                    width: "94%",
                    maxWidth: "100%",
                    textAlign: 'left',
                    fontSize: '16px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                    transition: '0.25s',
                    color: colors.softthinks,
                    lineHeight: '20px',
                    // textDecoration: 'underline'
                  }}
                >{location.label}
                </span>
              </ListSubheader >
            )
          }
        }
        )

      ) : (
        <div>
        </div>
      )}
    </Select>
  );
}
